import { USER_INFO_RECEIVED, USER_LOGGED_IN, USER_LOGGED_OUT, LOGIN_FAILED } from "../Constants";

export default function (state = {}, action) {
    switch (action.type) {
    case USER_INFO_RECEIVED:
    case USER_LOGGED_IN:
        return action.payload;

    case USER_LOGGED_OUT:
        return {};

    case LOGIN_FAILED:
        return Object.keys(action.payload).length > 0 ? {} : state;

    default:
        return state;
    }
}